module.exports = __webpack_public_path__ + "img/index_logo.94cecf99.svg";